export function concatClassnames(
  ...classes: (false | null | undefined | string)[]
) {
  return classes.filter(Boolean).join(" ");
}
